var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jf-divider"},[_c('div',{staticClass:"jf-divider-container"},[_c('div',{staticClass:"jf-divider-header"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"jf-divider-line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }